.bu{max-width:100%;}